import { Component } from 'react';
import styled from 'styled-components';

import Card from '../../components/Card';
import CardHeader from '../../components/CardHeader';
import AuctionBarGraph from './components/AuctionBarGraph';
import AuctionIndicators from './components/AuctionIndicators';
import AuctionPieChart from './components/AuctionPieChart';
import AuctionFilters from './components/AuctionFilters';
import Pills from '../../components/Pills';
import Select from '../../components/Select';
import ExportButton from '../../components/Export';
import AuctionStackGraph from './components/AuctionStackGraph';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { getAuction } from '../../actions/auction';
import moment from 'moment';
import Spinner from '../../components/Spinner';
import getAllUrlParams from '../../utils/getUrlParams';
import { I18n } from 'react-redux-i18n';

import Header from 'components/Header';
import Kpi from 'components/Kpi';
import Carousel from 'components/Carousel';
import CarouselItem from './components/CarouselItem';

const AuctionContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 20px;

  .headerContainer {
    margin-top: 22px;
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
  }

  .navigation {
    margin-top: 20px;
  }

  @media (min-width: 845px) {
    .surveyContent {
      line-height: 15px;
    }

    .pagination {
      margin-left: auto;
      margin-right: 13px;
      padding-left: 10px;
    }
  }

  .headerContainer {
    margin-top: 22px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: 1400px) {
    .pagination {
      margin-right: auto;
    }

    .headerContainer {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px;
  }
`;

const AuctionTabContainer = styled.div`
  .valueAndVolumeContainer {
    margin-top: 20px;
  }

  .valueAndVolumeContent {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2%;
    margin-top: 20px;
  }

  .rowLayout {
    display: grid;
    grid-gap: 20px;
    margin-top: 20px;
    grid-template-columns: 1fr 1fr;
  }
  .rowLayout > * {
    height: 100%;
  }

  .rightComponentsHeader {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .rightHeaderContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
  }

  .rightHeaderContainer > :not(:last-child) {
    margin-right: 20px;
  }
`;

class AuctionTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      indexKpi: 0,
      type: 'value',
      format: 'all',
      startVintage: null,
      endVintage: null,
      currency: 'EUR',
      market: null,
      startDate: moment().subtract(1, 'year'),
      endDate: moment(),
      stackGraphSelectedRivals: []
    };
  }

  async componentDidMount() {
    if (window.location.search) {
      const options = getAllUrlParams(window.location.href);
      await this.props.getAuction(options);
    } else {
      await this.props.getAuction();
    }
    this.setState({ loading: false });
  }

  componentDidUpdate(prevProps) {
    const { wine, market } = this.state;

    if (prevProps !== this.props && prevProps.data !== this.props.data) {
      if (!wine) {
        const wine = get(this.props.data, 'filters.client_wines[0].name');
        this.setState({
          wine: { label: wine, value: wine },
          stackGraphSelectedRivals: this.getRivalsStackGraph({
            label: wine,
            value: wine
          })
        });
      }

      this.setState({
        displayed_currency: get(this.props.data, 'kpis.displayed_currency'),
        currency: market
          ? get(this.props.data, 'kpis.local_currency')
          : get(this.props.data, 'kpis.displayed_currency')
      });
    }
  }

  formatHeaderKpi() {
    const { header_kpi = {} } = this.props.data;
    const formattedHeaderKpi = { ...header_kpi };
    Object.keys(formattedHeaderKpi).forEach((key) => {
      formattedHeaderKpi[key] = { ...formattedHeaderKpi[key], label: key };
    });
    return Object.values(formattedHeaderKpi);
  }

  showButtonAndUpdateKpi(kpis) {
    const { indexKpi } = this.state;
    this.setState({
      indexKpi:
        indexKpi == kpis.length - 1 || kpis.length < 2 ? 0 : indexKpi + 1
    });
  }

  renderFeed() {
    const { indexKpi } = this.state;
    const { feed = [] } = this.props.data;
    const kpis = this.formatHeaderKpi();
    const kpi = kpis[indexKpi]
      ? kpis[indexKpi]
      : { count: 0, label: '', since: null };
    return (
      <div className="headerContainer">
        <Kpi
          value={kpi.count}
          valueText={I18n.t('auction.kpiText')}
          title={kpi.label}
          date={kpi.since}
          handleNext={
            kpis && kpis.length > 1
              ? () => this.showButtonAndUpdateKpi(kpis)
              : undefined
          }
        />
        <Carousel ItemComponent={CarouselItem} data={feed} />
      </div>
    );
  }

  getVintageOptions() {
    const { volumes_and_values = [] } = this.props.data;
    return [...new Set(volumes_and_values.map((item) => item.bottle_vintage))]
      .sort()
      .reverse()
      .map((item) => ({ value: item, label: item }));
  }

  renderHeaderRightComponents() {
    const { startVintage, endVintage, type, format } = this.state;
    const options = this.getVintageOptions();

    return (
      <div className="rightComponentsHeader ignored-export">
        <Pills
          options={[
            {
              label: I18n.t('auction.auction.valueVolume.pillPrice'),
              value: 'value'
            },
            {
              label: I18n.t('auction.auction.valueVolume.pillVolume'),
              value: 'volume'
            }
          ].map((item) => ({
            ...item,
            active: item.value === type
          }))}
          onChange={({ value }) => this.setState({ type: value })}
        />
        <Pills
          options={[
            {
              label: I18n.t('placeholderAll'),
              value: 'all'
            },
            {
              label: I18n.t('auction.auction.valueVolume.pill750'),
              value: '750'
            }
          ].map((item) => ({
            ...item,
            active: item.value === format
          }))}
          onChange={({ value }) => this.setState({ format: value })}
        />
        <div className="rightHeaderContainer ignored-export">
          <p>{I18n.t('auction.auction.vintageChoice')}</p>
          <Select
            value={startVintage}
            onChange={(value) => this.setState({ startVintage: value })}
            options={options}
            placeholder={I18n.t('placeholderAll')}
            dropdownProps={{
              styles: `margin-left:-25px`
            }}
          />
          <p> - </p>
          <Select
            value={endVintage}
            onChange={(value) => this.setState({ endVintage: value })}
            options={options}
            placeholder={I18n.t('placeholderAll')}
            dropdownProps={{
              styles: `margin-left:-25px`
            }}
          />
          <ExportButton
            jpg
            pdf
            xls
            targetElement="#auction-valeur-volume"
            path="/api/v1/clients/me/vae/xls/"
            name={`${I18n.t(
              'auction.auction.valueVolume.title'
            )}-${this.getExportName()}`}
            options={{
              start_date: get(this.state, 'startDate').format('YYYY-MM-DD'),
              end_date: get(this.state, 'endDate').format('YYYY-MM-DD'),
              wines: get(this.state, 'wine.label')
                ? JSON.stringify([get(this.state, 'wine.label')])
                : false,
              store: get(this.state, 'store.label')
                ? get(this.state, 'store.label')
                : false
            }}
          />
        </div>
      </div>
    );
  }

  getExportName() {
    return `${
      get(this.state, 'market')
        ? get(this.state, 'market')
        : I18n.t('placeholderAll')
    }-${
      get(this.state, 'wine.label')
        ? get(this.state, 'wine.label')
        : I18n.t('placeholderAll')
    }`;
  }

  getOptions() {
    const options = { ...this.props.data.filters };
    Object.keys(options).forEach(
      (keysOptions) =>
        (options[keysOptions] = options[keysOptions].map((item) => ({
          label: item.name,
          value: item.name
        })))
    );
    return options;
  }

  getTotal(data) {
    const { type, currency, displayed_currency } = this.state;
    let property = 'price';
    if (currency !== displayed_currency) {
      property = 'local_price';
    }
    if (type === 'volume') {
      property = 'quantity';
    }
    return data
      .map((item) => item[property])
      .reduce((acc, base) => acc + base, 0);
  }

  filterData() {
    const { format, startVintage, endVintage } = this.state;
    const { volumes_and_values = [] } = this.props.data;
    let filteredData = [...volumes_and_values];

    filteredData = filteredData.filter(
      (item) => format === 'all' || Number(item.bottle_format) === 750
    );
    filteredData = filteredData.filter(
      (item) =>
        (!startVintage || startVintage.value <= item.bottle_vintage) &&
        (!endVintage || endVintage.value >= item.bottle_vintage)
    );
    return filteredData;
  }

  getSums(data) {
    const sumQuantityStore = {};
    const sumQuantityMarket = {};
    const sumQuantityMarketStore = {};
    const sumQuantityWineStore = {};
    const sumPriceStore = {};
    const sumPriceMarket = {};
    const sumPriceMarketStore = {};
    const sumPriceWineStore = {};
    const sumLocalStore = {};
    const sumLocalMarket = {};
    const sumLocalMarketStore = {};
    const sumLocalWineStore = {};

    data.forEach((item) => {
      //quantity/store
      sumQuantityStore[item.store_name] = sumQuantityStore[item.store_name]
        ? sumQuantityStore[item.store_name] + item.quantity
        : item.quantity;

      //quantity/store
      sumQuantityMarket[item.market_name] = sumQuantityMarket[item.market_name]
        ? sumQuantityMarket[item.market_name] + item.quantity
        : item.quantity;

      if (sumQuantityMarketStore[item.market_name]) {
        sumQuantityMarketStore[item.market_name][item.store_name] =
          sumQuantityMarketStore[item.market_name][item.store_name]
            ? sumQuantityMarketStore[item.market_name][item.store_name] +
              item.quantity
            : item.quantity;
      } else {
        sumQuantityMarketStore[item.market_name] = {
          [item.store_name]: item.quantity
        };
      }

      if (sumQuantityWineStore[item.wine_name]) {
        sumQuantityWineStore[item.wine_name][item.store_name] =
          sumQuantityWineStore[item.wine_name][item.store_name]
            ? sumQuantityWineStore[item.wine_name][item.store_name] +
              item.quantity
            : item.quantity;
      } else {
        sumQuantityWineStore[item.wine_name] = {
          [item.store_name]: item.quantity
        };
      }

      //quantity/store
      sumPriceStore[item.store_name] = sumPriceStore[item.store_name]
        ? sumPriceStore[item.store_name] + item.price
        : item.price;

      //quantity/store
      sumPriceMarket[item.market_name] = sumPriceMarket[item.market_name]
        ? sumPriceMarket[item.market_name] + item.price
        : item.price;

      if (sumPriceMarketStore[item.market_name]) {
        sumPriceMarketStore[item.market_name][item.store_name] =
          sumPriceMarketStore[item.market_name][item.store_name]
            ? sumPriceMarketStore[item.market_name][item.store_name] +
              item.price
            : item.price;
      } else {
        sumPriceMarketStore[item.market_name] = {
          [item.store_name]: item.price
        };
      }

      if (sumLocalWineStore[item.wine_name]) {
        sumLocalWineStore[item.wine_name][item.store_name] = sumLocalWineStore[
          item.wine_name
        ][item.store_name]
          ? sumLocalWineStore[item.wine_name][item.store_name] +
            item.local_price
          : item.local_price;
      } else {
        sumLocalWineStore[item.wine_name] = {
          [item.store_name]: item.local_price
        };
      }

      //quantity/store
      sumLocalStore[item.store_name] = sumLocalStore[item.store_name]
        ? sumLocalStore[item.store_name] + item.local_price
        : item.local_price;

      //quantity/store
      sumLocalMarket[item.market_name] = sumLocalMarket[item.market_name]
        ? sumLocalMarket[item.market_name] + item.local_price
        : item.local_price;

      if (sumLocalMarketStore[item.market_name]) {
        sumLocalMarketStore[item.market_name][item.store_name] =
          sumLocalMarketStore[item.market_name][item.store_name]
            ? sumLocalMarketStore[item.market_name][item.store_name] +
              item.local_price
            : item.local_price;
      } else {
        sumLocalMarketStore[item.market_name] = {
          [item.store_name]: item.local_price
        };
      }

      if (sumPriceWineStore[item.wine_name]) {
        sumPriceWineStore[item.wine_name][item.store_name] = sumPriceWineStore[
          item.wine_name
        ][item.store_name]
          ? sumPriceWineStore[item.wine_name][item.store_name] + item.price
          : item.price;
      } else {
        sumPriceWineStore[item.wine_name] = {
          [item.store_name]: item.price
        };
      }
    });

    return {
      sumQuantityStore,
      sumQuantityMarket,
      sumQuantityMarketStore,
      sumQuantityWineStore,
      sumPriceStore,
      sumPriceMarket,
      sumPriceMarketStore,
      sumPriceWineStore,
      sumLocalStore,
      sumLocalMarket,
      sumLocalMarketStore,
      sumLocalWineStore
    };
  }

  formatValueMarket(market, store, sums) {
    const { type, currency = 'EUR', displayed_currency = 'EUR' } = this.state;
    if (type === 'value') {
      if (currency === displayed_currency) {
        return get(
          sums,
          `sumPriceMarketStore[${market}][${store}]`,
          '0'
        ).toLocaleString('fr-FR', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 1
        });
      } else {
        return get(
          sums,
          `sumLocalMarketStore[${market}][${store}]`,
          '0'
        ).toLocaleString('fr-FR', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 1
        });
      }
    }
    return sums.sumQuantityMarketStore[market][store] + ' bt.';
  }

  formatPieData(data, total, sums) {
    const { type, currency = 'EUR', displayed_currency = 'EUR' } = this.state;
    const formattedData = {};

    data.forEach((item) => {
      if (!formattedData[item.store_name]) {
        formattedData[item.store_name] = { name: item.store_name, markets: [] };
        if (type === 'value') {
          formattedData[item.store_name].value =
            currency === displayed_currency
              ? sums.sumPriceStore[item.store_name]
              : sums.sumLocalStore[item.store_name];
          formattedData[item.store_name].percentage =
            currency === displayed_currency
              ? Number(
                  (sums.sumPriceStore[item.store_name] / total) * 100
                ).toFixed(1) + '%'
              : Number(
                  (sums.sumLocalStore[item.store_name] / total) * 100
                ).toFixed(1) + '%';
        } else {
          formattedData[item.store_name].value =
            sums.sumQuantityStore[item.store_name];
          formattedData[item.store_name].percentage =
            Number(
              (sums.sumQuantityStore[item.store_name] / total) * 100
            ).toFixed(1) + '%';
        }
      }
      const marketNames = formattedData[item.store_name].markets.map(
        (item) => item.name
      );
      if (!marketNames.includes(item.market_name)) {
        formattedData[item.store_name].markets.push({
          name: item.market_name,
          value: this.formatValueMarket(item.market_name, item.store_name, sums)
        });
      }
    });
    return Object.values(formattedData);
  }

  formatValueStackChart(wine, store, sums) {
    const { type, currency, displayed_currency = 'EUR' } = this.state;
    if (type === 'value') {
      if (currency === displayed_currency) {
        return sums.sumPriceWineStore[wine][store];
      } else {
        return sums.sumLocalWineStore[wine][store];
      }
    }
    return sums.sumQuantityWineStore[wine][store];
  }

  formatStackChart(data, sums) {
    let formattedData = {};
    const { wine, stackGraphSelectedRivals } = this.state;
    const possibleWines = [
      ...stackGraphSelectedRivals.map((item) => item.label),
      wine ? wine.label : ''
    ];

    data = data.filter((item) => possibleWines.includes(item.wine_name));
    data.forEach((item) => {
      if (!formattedData[item.store_name]) {
        formattedData[item.store_name] = [
          {
            name: item.wine_name,
            value: this.formatValueStackChart(
              item.wine_name,
              item.store_name,
              sums
            ),
            store_name: item.store_name
          }
        ];
      } else {
        const wineNames = formattedData[item.store_name].map(
          (item) => item.name
        );
        if (!wineNames.includes(item.wine_name)) {
          formattedData[item.store_name].push({
            name: item.wine_name,
            value: this.formatValueStackChart(
              item.wine_name,
              item.store_name,
              sums
            ),
            store_name: item.store_name
          });
        }
      }
    });
    formattedData = Object.values(formattedData);

    let dataNames = [];
    formattedData.forEach((set) => {
      if (set && set.length > 0) {
        dataNames.push(...set.map((item) => item.name));
      }
    });
    dataNames = [...new Set(dataNames)];
    formattedData.forEach((set) => {
      const setNames = set.map((item) => item.name);
      const missingNames = dataNames.filter((item) => !setNames.includes(item));
      missingNames.forEach((missingName) => {
        set.push({
          name: missingName,
          store_name: get(set, '[0].store_name'),
          value: 0
        });
      });

      set.sort((a, b) => String(a.name).localeCompare(String(b.name)));
    });
    return formattedData;
  }

  filterDataClient(data) {
    const { wine } = this.state;
    return [...data.filter((item) => !wine || item.wine_name === wine.value)];
  }

  async handleChangeFilter(field, value) {
    const {
      wine,
      store,
      market,
      startDate,
      endDate,
      stackGraphSelectedRivals
    } = this.state;
    this.setState({
      [field]: value,
      stackGraphSelectedRivals:
        field === 'wine'
          ? this.getRivalsStackGraph(value)
          : stackGraphSelectedRivals,
      loading: true
    });
    await this.props.getAuction({
      wines: field === 'wine' ? value.value : wine.value,
      store:
        field === 'store'
          ? get(value, 'value', 'Tous')
          : get(store, 'value', ''),
      start_date:
        field === 'startDate'
          ? moment(value).format('YYYY-MM-DD')
          : moment(startDate).format('YYYY-MM-DD'),
      end_date:
        field === 'endDate'
          ? moment(value).format('YYYY-MM-DD')
          : moment(endDate).format('YYYY-MM-DD'),
      market:
        field === 'market'
          ? get(value, 'value', 'Tous')
          : get(market, 'value', '')
    });
    this.setState({ loading: false });
  }

  getDataKpis() {
    const { kpis } = this.props.data;
    if (!kpis) {
      return {
        wine_name: '',
        local_currency: 'EUR',
        displayed_currency: 'EUR',
        date: moment(),
        min_price: 0,
        min_local_price: 0,
        min_vintage: '',
        min_store: '',
        min_market: '',
        min_date: moment(),
        avg_price: 0,
        avg_local_price: 0,
        total_bottles: 0,
        total_sales: 0
      };
    }
    return kpis;
  }

  getRivalsStackGraph(defaultWine) {
    let wine = null;
    const { wine: wineState } = this.state;
    wine = defaultWine ? defaultWine : wineState;

    if (!wine) {
      return [];
    }
    const clientWines = get(this.props, 'data.filters.client_wines', []);
    if (!clientWines || clientWines.length === 0) {
      return [];
    }
    const selectedClientWine = clientWines.find(
      (item) => item.name === wine.label
    );
    return selectedClientWine && selectedClientWine.rivals
      ? selectedClientWine.rivals.map((item) => ({ value: item, label: item }))
      : [];
  }

  render() {
    const { type, currency, displayed_currency, stackGraphSelectedRivals } =
      this.state;
    const options = this.getOptions();
    const filteredData = this.filterData();
    const sums = this.getSums(filteredData);
    const filteredDataClient = this.filterDataClient(filteredData);
    const sumsClient = this.getSums(filteredDataClient);
    const totalPieChart = this.getTotal(filteredDataClient);
    const pieData = this.formatPieData(
      filteredDataClient,
      totalPieChart,
      sumsClient
    );
    const stackData = this.formatStackChart(filteredData, sums);
    const { avg_prices = [] } = this.props.data;
    const kpis = this.getDataKpis();

    return (
      <AuctionContainer>
        <Header
          title={I18n.t('auction.title')}
          subTitle={I18n.t('auction.subTitle')}
        />
        {this.renderFeed()}

        <AuctionTabContainer>
          <AuctionFilters
            options={options}
            selection={this.state}
            onChange={(field, value) => this.handleChangeFilter(field, value)}
          />
          <Card id="auction-valeur-volume" className="valueAndVolumeContainer">
            <CardHeader
              alignItems="center"
              title={I18n.t('auction.auction.valueVolume.title')}
              rightComponents={this.renderHeaderRightComponents()}
              styles={`margin-left:-5px;.cardHeaderRight{width:100%;padding-left:20px;margin-left:0}`}
            />
            <div className="valueAndVolumeContent">
              <AuctionPieChart
                data={pieData}
                total={totalPieChart}
                type={type}
                currency={currency}
              />
              <AuctionStackGraph
                data={stackData}
                unity={type === 'volume'}
                currency={currency}
                selectedRivals={stackGraphSelectedRivals}
                rivalOptions={this.getRivalsStackGraph()}
                onChangeRivals={(value) =>
                  this.setState({
                    stackGraphSelectedRivals:
                      value && value.length > 5
                        ? value.slice(1, value.length)
                        : value
                  })
                }
              />
            </div>
          </Card>
          <div className="rowLayout">
            <AuctionBarGraph
              data={avg_prices}
              currency={currency}
              exportName={this.getExportName()}
              displayed_currency={displayed_currency}
            />
            <AuctionIndicators data={kpis} />
          </div>
        </AuctionTabContainer>
        <Spinner loading={this.state.loading} />
      </AuctionContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.auction
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAuction: async (options) => {
      await dispatch(getAuction(options));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionTab);
